<template>
  <div>
    <el-row style="height: 40px">
      <el-col :span="2"><el-tag type="info">商品详情</el-tag></el-col>
      <el-col :span="15">
        <el-button type="primary" size="small" @click="getTbSendItem">同步商品信息</el-button>
        订单号：<el-input v-model="tid" size="small" type="text"  style="width:200px"></el-input>
        <el-button type="primary" size="mini" @click="getSendItem">搜索</el-button>
      </el-col>
      <el-col :span="2"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table border :data="itemData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column  label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="title" label="标题" ></el-table-column>
          <el-table-column  prop="numIid" label="商品ID" width="200px"></el-table-column>
          <el-table-column  prop="skuId" label="SkuId" width="200px"></el-table-column>
          <el-table-column  prop="price" label="价格" width="200px"></el-table-column>


        </el-table>
      </el-col>
    </el-row>
    <div class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>
  </div>

</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

  export default {
    name: "SendItem",
    data(){
      return{
        tid:'',
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 100,
        },

        itemData:[],
        tbUser:{
          nick:'',
          subNick:'',
          appkey: '',
          sessionkey:''
        },
      }
    },
    methods:{
      indexMethod(index){
        return index+1;
      },
      //改变pageSize
      handleSizeChange: function (val) {
        this.pageObject.pageSize = val;
        this.getSendItem();
      },
      //当前页面改变
      handleCurrentChange: function (val) {
        this.pageObject.pageCurrent = val;
        this.getSendItem();
      },
      getSendItem:function () {
        let param ={
          nick:storage.get("nick"),
          pageCurrent: this.pageObject.pageCurrent,
          rowCount: this.pageObject.rowCount,
          pageSize: this.pageObject.pageSize,
        };
        $api.post("/item/sendItem", param, response => {
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok") {
            let itemData = dataResult.data.list;
            let pageObject = dataResult.data.pageObject;
            this.itemData = itemData;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;
          }else {
            this.$message.error(dataResult);
          }
        })
      },
      getTbSendItem:function () {
        let param ={
          nick:storage.get("nick"),
          pageCurrent: this.pageObject.pageCurrent,
          rowCount: this.pageObject.rowCount,
          pageSize: this.pageObject.pageSize,
        };
        $api.post("/item/getTbSendItem", param, response => {
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok") {
            this.getSendItem();
          }else {
            this.$message.error(dataResult);
          }
        })
      }

    },
    mounted() {
      this.getSendItem();
    }
  }
</script>

<style >
  a{
    color: #409EFF;
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/auto/SendItem.vue